var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#808284"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 20.5498V22.0498C18.45 22.1998 18.3 22.3498 18.3 22.4998C18.15 22.6498 18 22.6498 17.85 22.6498H12.3C12.15 22.6498 12 22.4998 11.85 22.4998C11.7 22.3498 11.7 22.1998 11.7 22.0498V20.5498C11.7 20.3998 11.85 20.2498 11.85 20.0998C12 19.9498 12.15 19.9498 12.3 19.9498H13.05V16.0498H12.3C12.15 16.0498 12 16.0498 11.85 15.8998C11.7 15.7498 11.7 15.5998 11.7 15.4498V13.9498C11.7 13.7998 11.85 13.6498 11.85 13.4998C12 13.1998 12.15 13.0498 12.3 13.0498H16.2C16.35 13.0498 16.5 13.1998 16.65 13.1998C16.8 13.3498 16.8 13.4998 16.8 13.6498V19.6498H17.55C17.7 19.6498 17.85 19.6498 18 19.7998C18.3 20.2498 18.45 20.3998 18.45 20.5498Z",
    fill: "#F68121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 7.3501C17.25 7.8001 17.55 8.4001 17.55 9.1501C17.55 9.9001 17.25 10.5001 16.8 10.9501C16.35 11.4001 15.75 11.7001 15 11.7001C14.25 11.7001 13.65 11.5501 13.2 10.9501C12.75 10.5001 12.45 9.9001 12.45 9.1501C12.45 8.4001 12.75 7.9501 13.2 7.3501C13.65 6.9001 14.25 6.6001 15 6.6001C15.75 6.6001 16.35 6.9001 16.8 7.3501Z",
    fill: "#F68121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFocus);
export default __webpack_public_path__ + "static/media/settings-focus.cf029cfb90e3515dcab2d8043cd73817.svg";
export { ForwardRef as ReactComponent };